export const RBAC_DISABLED_MESSAGE = 'You do not have permission to perform this action';
export const RBAC_RESOLVED_ROLE_MESSAGE =
  'This role has been granted automatically because you have higher permissions';
export const RBAC_OBSERVER_DISABLED_MESSAGE =
  'The Observer role is assigned by default to all team members';
export const RBAC_V2_DEFAULT_DISABLED_MESSAGE =
  'Unable to perform the fetch to check if the action is disabled, please refresh the page';
